import axios from '../modules/AxiosInstance';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';
import Environment from '../modules/Environment';
import UriUtils from '../modules/UriUtils';
import store from '../store';

const AutopayService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.searchAutopayEnrollments = (searchFields) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(searchFields);
    return axios.get(`${BASE_URL}/autopay/search${queryString}`, {
      headers,
    });
  };

  service.getAutopayActivity = (serviceOfferingId, startTime, endTime) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.post(`${BASE_URL}/autopay/activity`, { serviceOfferingId, startTime, endTime, }, {
      headers,
    });
  };

  service.getAutopayBills = (serviceOfferingId, dueDate) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.post(`${BASE_URL}/autopay/bills`, { serviceOfferingId, dueDate, }, {
      headers,
    });
  };

  service.getUpcomingPayment = (query) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(query);
    return axios.get(`${BASE_URL}/autopay/upcoming${queryString}`, {
      headers,
    });
  };

  service.updateAutopayEnrollment = (data) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.put(`${BASE_URL}/autopay/update`, {
      autopayEnrollmentId: data.autopayEnrollmentId,
      autopayEnrollmentStatus: data.autopayEnrollmentStatus,
    }, {
      headers,
    });
  };

  service.getAggregateBillData = (soid, dueDate) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/autopay/data/service-offerings/${soid}/aggregate-bills/due/${dueDate}`, {
      headers,
    }).then(response => response.data);
  };

  service.getBillSummaries = (soid, startDueDate, endDueDate, page = 0, size = 100) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/autopay/data/service-offerings/${soid}/bill-summaries/due/${startDueDate}/to/${endDueDate}`, {
      headers,
      params: { page, size, },
    }).then(response => response.data);
  };

  return service;
})();

export default AutopayService;
